export const GET_LIST_EINVOICE = 'ev00-invoice/ev24-get-list-einvoice';
export const GET_LIST_SEARCH_STATUS = 'ev00-invoice/ev25-get-all-search-bar-einvoice'
export const GET_LIST_SEARCH_AND_HEADER = 'ev00-invoice/ev37-get-search-bar-invoice-from-module'
export const GET_LIST_MODULE = 'ev00-invoice/ev38-get-all-module'
export const GET_EINVOICE_CONFIGURATION = 'ev00-invoice/ev39-get-einvoice-configuration'
export const UPDATE_EINVOICE_CONFIGURATION = 'ev00-invoice/ev40-update-einvoice-configuration'
export const GET_PAYMENT_METHODS = 'ev00-invoice/ev23-get-paymentmethod'
export const CREATE_EINVOICE = 'ev00-invoice/ev36-create-einvoice'
export const SIGN_EINVOICE = 'ev00-invoice/ev35-sign-einvoice'
export const GET_DETAIL_EINVOICE = 'ev00-invoice/ev03-get-einvoice-detail'
export const CREATE_DRAFT_EINVOICE = 'ev00-invoice/ev27-create-draft-einvoice'
export const UPDATE_SEARCH_BAR_BY_FILTER = 'ev00-invoice/ev41-update-search-bar-by-filter'
export const ADJUST_REPLACE_EINVOICE = 'ev00-invoice/ev11-adjust-replace'
export const DELETE_EINVOICE = 'ev00-invoice/ev09-delete'
export const CANCEL_EINVOICE = 'ev00-invoice/ev16-cancel'
export const PUBLISH_EINVOICE = 'ev00-invoice/ev26-create-publish-einvoice'
export const GET_LIST_INVOICE_FROM_MODULE = 'ev00-invoice/ev42-get-list-invoice-from-module'
export const GET_LIST_INVOICE_DETAIL_FROM_MODULE = 'ev00-invoice/ev43-get-list-invoice-detail-from-module'
export const VIEW_PDF = 'ev00-invoice/ev17-download-pdf'
export const PREVIEW_PDF = 'ev00-invoice/ev44-preview'
export const CHANGE_EINVOICE = 'ev00-invoice/ev44-change'
export const EXPORT_EXCEL = 'ev00-invoice/ev46-export-excel-list-einvoice'
export const GET_NUMBER_EINVOICE_UPDATE_TAXAUTHORITY = 'ev00-invoice/ev47-get-number-einvoice-update-tax-authority'
export const SEND_INVOICE_CQT = 'ev00-invoice/ev21-send-cqt'
export const GET_LIST_HOTEL_BY_MODULE = 'ev00-invoice/ev48-get-list-hotel-from-module'
export const GET_INVOICE_STATUS_CQT = 'ev00-invoice/ev22-get-invoicestatus'
export const UPDATE_INVOICE_STATUS_CQT_MUL = 'ev00-invoice/ev49-update-invoice-status-cqt';
export const GET_AUTO_LIST_INVOICE_FROM_MODULE = 'ev00-invoice/ev50-get-list-invoice-from-module-auto';
export const GET_DETAIL_EINVOICE_RESERVATION_THIRD_API = 'ev00-invoice/ev51-get-detail-einvoice-reservation';
export const SEARCH_BY_EZINVOICEID = 'ev00-invoice/ev52-search-by-ezInvoiceId';
export const EDIT_DRAFT_EINVOICE = 'ev00-invoice/ev53-edit-draft-einvoice';
export const PREVIEW_TEMP_PDF_EINVOICE = 'ev00-invoice/ev54-preview-temp-pdf-einvoice';
export const CREATE_INTERNAL_DRAFT_EINVOICE = 'ev00-invoice/ev55-create-internal-einvoice';
export const EDIT_INTERNAL_DRAFT_EINVOICE = 'ev00-invoice/ev56-edit-internal-draft-einvoice';
export const GET_INTERNAL_STATUS = 'ev00-invoice/ev57-get-internal-status';
